import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { ProductListComp } from './components';
import { Title } from 'app/components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 3, 8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 6),
    },
  },
}));

function ProductList() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Title prefix="Products" />
      <ProductListComp />
    </Box>
  );
}

export default ProductList;
